import type { HomeworkTocItem } from '../services/homeworkApi'

function slugify(text: string, used: Set<string>): string {
  const base =
    text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60) || 'section'
  let id = base
  let n = 2
  while (used.has(id)) {
    id = `${base}-${n}`
    n += 1
  }
  used.add(id)
  return id
}

/** Gắn id cho H1–H6 trong container (giữ id sẵn có), trả về TOC khớp DOM. */
export function ensureHeadingIds(root: HTMLElement): HomeworkTocItem[] {
  const used = new Set<string>()
  const toc: HomeworkTocItem[] = []
  root.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach((node) => {
    const el = node as HTMLElement
    const level = Number(el.tagName.replace('H', '')) || 1
    const text = (el.textContent || '').replace(/\s+/g, ' ').trim()
    let id = (el.getAttribute('id') || '').trim()
    if (!id || used.has(id)) {
      id = slugify(text || `h${level}`, used)
      el.id = id
    } else {
      used.add(id)
    }
    toc.push({ id, level, text: text || id })
  })
  return toc
}

const HEADER_OFFSET = 88

export function scrollToHomeworkHeading(
  id: string,
  opts?: { text?: string; rootSelector?: string }
): boolean {
  const root =
    (opts?.rootSelector
      ? document.querySelector(opts.rootSelector)
      : document.querySelector('.homework-annotation-body')) || document.body

  let el: HTMLElement | null = null
  try {
    el = root.querySelector(`#${CSS.escape(id)}`) as HTMLElement | null
  } catch {
    el = document.getElementById(id)
  }
  if (!el) el = document.getElementById(id)

  if (!el && opts?.text) {
    const needle = opts.text.replace(/\s+/g, ' ').trim()
    const headings = Array.from(root.querySelectorAll('h1,h2,h3,h4,h5,h6')) as HTMLElement[]
    el =
      headings.find((h) => (h.textContent || '').replace(/\s+/g, ' ').trim() === needle) || null
  }

  if (!el) return false

  const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
  el.classList.add('homework-toc-flash')
  window.setTimeout(() => el?.classList.remove('homework-toc-flash'), 1200)
  return true
}
